import React from 'react';
import {Link} from 'react-router-dom';
const FormGuarantee = ()=>{
    return(
        <p className="font-italic text-center">
            We are proud to offer a quality guarantee on all our legal documents and forms. Should you find any error in any of our documents, just send us an email at <a href="mailto:support@contracts.ph">support@contracts.ph</a> or <Link to="/contact">click here to send us a message</Link> and we will make it right for you.
        </p>
    );
}
export default FormGuarantee;


// WEBPACK FOOTER //
// ./src/view/FormGuarantee.js